import React from "react"
import { useTranslation } from "react-i18next"

const VERSION_NO = 1.1
const Footer = () => {
    const { t } = useTranslation()
    const currentYear = new Date().getFullYear() // Get the current year dynamically
    return (
        <>
            <div className="no-print flex px-12 py-3 justify-center 
            align-center gap-2.5 border-t border-solid border-secondary-300 dark:border-darkBorder bg-white dark:bg-darkBg">
                <div className="text-sm text-secondary-50 dark:text-darkText">
                    <span className="pr-2">
                        <a
                            href="https://privacypolicy.pg.com/en-US"
                            target="_blank"
                            title={ t("Home.privacyPolicy") }
                            rel="noreferrer"
                            className="text-blue-500 hover:underline dark:text-blue-400"
                        >
                            { t("Home.privacyPolicy") }
                        </a>
                    </span>
                    <span className="border-l border-secondary-700 dark:border-darkBorder h-4 pl-2">
                        <a
                            href="https://termsandconditions.pg.com/en-us"
                            target="_blank"
                            title={ t("Home.termsAndConditions") }
                            rel="noreferrer"
                            className="text-blue-500 hover:underline dark:text-blue-400"
                        >
                            { t("Home.termsAndConditions") }
                        </a>
                    </span>
                </div>
            </div>
            <div className="no-print flex px-12 py-3 justify-center 
            align-center gap-2.5 bg-white dark:bg-darkBg">
                <div className="text-sm text-secondary-50 dark:text-darkText">
                    © { currentYear } { t("Home.procterGamble") } { t("Home.version") } { VERSION_NO }
                </div>
            </div>
        </>
    )
}

export default Footer
